import useReservationRestClient from "@app-rest/reservations";
import { IFootwear, IOfferQueryDate, IOfferQueryPagination, IOffersQuery, IShoesCategory } from "@app-rest/reservations.interfaces";
import useSystemStore from "@app-store/system";
import { ref } from "vue";

const shoes = ref<IFootwear[] | null> ([]);
const socks = ref<IFootwear[] | null> ([]);
const shoesCategory = ref<IShoesCategory[] | null> ([]);

export function useReservationFootwears() {

	const syncFootwears = async(query: IOffersQuery & IOfferQueryDate & Partial<IOfferQueryPagination>) => {
		const restClient = useReservationRestClient();
		const response = await restClient.footwears(query);
		shoes.value = response.data?.Shoes ?? null;
		socks.value = response.data?.Socks ?? null;
	}

	const syncShoesCategory = async() => {
		const restClient = useReservationRestClient();
		const response = await restClient.getShoesCategory(Number(useSystemStore().info?.Id));
		shoesCategory.value = response.data?.CategoriesShoesSizes ?? null;
	}

	return {
		shoes,
		socks,
		shoesCategory,
		syncFootwears,
		syncShoesCategory,
	}
}
